<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container" style="text-align: center">
      <div>
        <div class="headerright">江苏锁安科技有限公司</div>
      </div>
      <div
        style="
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
          width: 900px;
          display: inline-flex;
          justify-content: space-between;
          background-color: #fff;
          border: 20px solid #e8f0ff;
          border-bottom-right-radius: 15px;
          border-top-left-radius: 34px;
          z-index: 999;
        "
      >
        <!--左图-->
        <div class="image" style="height: 550px; width: 400px; text-align: center">
          <span class="title">LOCKAN</span>
        </div>
        <!--右图-->
        <div style="padding: 0 25px; height: 550px; overflow-y: auto">
          <div class="top" style="margin-top: 40px">
            <div class="header">
              <a href="/">
                <img src="~@/assets/logo2.png" class="logo" alt="logo" />
              </a>
            </div>
            <div class="desc"></div>
          </div>
          <route-view></route-view>
        </div>
      </div>
      <div class="footer">
        <div class="copyright">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            style="text-decoration: none; color: rgba(0, 0, 0, 0.45)"
          >
            <a-icon type="copyright" />
            <span>
              {{ online ? '江苏锁安科技 苏ICP备17043972号-3' : '南京迈特望科技股份有限公司 苏ICP备05059565号-7' }}
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteView from './RouteView'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'UserLayout',
  components: { RouteView },
  mixins: [mixinDevice],
  data() {
    return {}
  },
  computed: {
    online() {
      return location.host == 'lockan.maitewang.com' || location.host == 'sjlockan.maitewang.com'
    },
  },
  mounted() {
    document.body.classList.add('userLayout')
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  },
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;

  &.mobile {
    .container {
      .main {
        max-width: 368px;
        width: 98%;
      }
    }
  }

  .container {
    width: 100%;
    height: 100%;
    min-height: 900px;
    background-image: url(~@/assets/background2.jpg);
    // background: #d9e6ff url(~@/assets/background2.png) no-repeat 50%;
    background-attachment: fixed;
    background-size: 100%;
    padding: 110px 0 144px;
    position: relative;

    a {
      text-decoration: none;
    }

    .image {
      background-size: 100% 100%;
      background-image: url('/loginImg/login1.png');
      background-repeat: no-repeat;
      border-top-left-radius: 15px;
      border-bottom-right-radius: 15px;
      .title {
        font-size: 33px;
        color: #fff;
        font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
        font-weight: 600;
        position: relative;
        top: 32px;
      }
    }
    .headerimage {
      height: 44px;
      line-height: 44px;
      position: fixed;
      left: 70px;
      top: 32px;
      img {
        height: 44px;
        vertical-align: top;
        /*margin-right: 16px;*/
        border-style: none;
        /*margin-left: -80%;*/
        /*margin-top: -6%;*/
      }
    }
    .headerright {
      position: fixed;
      right: 70px;
      top: 32px;
      font-size: 33px;
      color: #f2f2f2;
      font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
      font-weight: 600;
    }
    .top {
      text-align: center;

      .header {
        height: 44px;
        line-height: 44px;

        .badge {
          position: absolute;
          display: inline-block;
          line-height: 1;
          vertical-align: middle;
          margin-left: -12px;
          margin-top: -10px;
          opacity: 0.8;
        }

        .logo {
          height: 57px;
          vertical-align: top;
          /*margin-right: 16px;*/
          border-style: none;
        }

        .title {
          font-size: 33px;
          color: rgba(0, 0, 0, 0.85);
          font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
          font-weight: 600;
          position: relative;
          top: 2px;
        }
      }
      .desc {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 12px;
        margin-bottom: 20px;
      }
    }

    .main {
      min-width: 260px;
      width: 368px;
      margin: 0 auto;
    }

    .footer {
      z-index: 100;
      position: fixed;
      justify-content: center;
      width: 100%;
      bottom: 5%;
      padding: 0 16px;
      margin: 48px 0 24px;
      text-align: center;
      .links {
        margin-bottom: 8px;
        font-size: 14px;
        a {
          color: rgba(0, 0, 0, 0.45);
          transition: all 0.3s;
          &:not(:last-child) {
            margin-right: 40px;
          }
        }
      }
      .copyright {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
      }
    }
  }
}
</style>
